module.exports = __webpack_public_path__ + "static/media/dataleak.120d3dab.jpg";